export default "__VITE_ASSET__B9el8143__"